import { Component, Input, OnInit, Output, EventEmitter, trigger,
  state,
  style,
  animate,
  transition,
  keyframes } from '@angular/core';

import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PATTERNS } from "../../../../globals";
import { UserService } from "../../../../injections/user.service";
import { ModalEmailService } from "../../../../common/modal-email/modal-email.service";
import {Router, ActivatedRoute} from "@angular/router";
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'user-offices',
    templateUrl: '../../templates/partials/user-offices.html',
})

export class OfficesComponent implements OnInit {

    public editContactData: boolean = false;
    public addContactPerson: boolean = false;
    @Output() showModal = new EventEmitter();
    @Input() office;
    @Input() index;
    public contactPersonSelected = null;
    public officeData: FormGroup;
    public contactData: FormGroup;
    public subscriptionModal: Subscription;
    constructor(private _fb: FormBuilder, private userService: UserService, private router: Router, private modalEmailService: ModalEmailService) { }

    public showModalContact(contact: object){
        this.userService.showModal({type:"contact", data:contact});  
    }

    public toggleEditContactData(){
        this.editContactData = (this.editContactData) ? false : true;
    }

    public showEditContactPerson(contactPerson: object){
        this.parseFormData(contactPerson);
        this.addContactPerson = true;
    }

    public closeContactPerson(){
        this.addContactPerson = false;
    }

    public goCreateService(id: string) {
        //console.log(id);
        this.router.navigate(["/new-service", id]);
    }

    public removeOffice(office: object) {

        this.userService.showModal({type:"office",data: office});
    }

    public showMailModal(email: string){
        this.modalEmailService.openModalEmail(email);
    }

    public manageContactPerson(){
        //console.log(this.office);
        if(this.contactPersonSelected != null){
            let object = {
                contact_person_id: this.contactPersonSelected["id"],
                user_id: this.office["id_user"].toString(),
                office_id: this.office["id"].toString(),
                name: this.contactData.controls.name.value,
                surname: this.contactData.controls.surname.value,
                email: this.contactData.controls.mail.value,
                phone: this.contactData.controls.phone.value
            };
            this.editContactPerson(object);
        }else{
             let object = {
                user_id: this.office["id_user"].toString(),
                office_id: this.office["id"].toString(),
                name: this.contactData.controls.name.value,
                surname: this.contactData.controls.surname.value,
                email: this.contactData.controls.mail.value,
                phone: this.contactData.controls.phone.value
            };
            this.createContactPerson(object);
        }
    }

    public editContactPerson(object: object) {
        /*this.userService.editContactPerson(object).subscribe( 
            result => {
                if(result == "OK"){
                    this.addContactPerson = false;
                    this.office.contactPerson.forEach((element,i) => {
                        if(element["id"] == this.contactPersonSelected["id"]){
                            object["id"] = object["contact_person_id"];
                            //console.log(this.contactPersonSelected);
                            this.office.contactPerson[i] = object;
                        }
                    });
                }
            }
        );*/
    }

    public createContactPerson(object: object) {
        /*this.userService.createContactPerson(object).subscribe( 
            result => {
                //if(result == "OK"){
                    this.addContactPerson = false;
                    object["id"] = result["contactPersonId"];
                    if(this.office.contactPerson == null) this.office.contactPerson = [];
                    this.office.contactPerson.push(object);
                //}
            }
        );*/
    }

    public updateUserOffice() {
        //console.log(this.officeData);
        var object = {
            id_office: this.office["id"].toString(),
            name: this.officeData.controls.legalName.value,
            gyh_office: this.officeData.controls.officeGYH.value.toString(),
            products: (this.officeData.controls.products.value) ? "1" : "0",
            address: this.officeData.controls.street.value,
            number: this.officeData.controls.number.value,
            floor: this.officeData.controls.floor.value,
            door: this.officeData.controls.door.value,
            postal_code: this.officeData.controls.postal_code.value,
            notes: this.officeData.controls.note.value,
            city: 'ES',
            country: this.office["country"],
        };
        
        /*this.userService.upadateUserOffice(object).subscribe( 
            result => {
                if(result == "OK"){
                    this.setDataValues(object);
                    this.editContactData = false;
                    //console.log(this.office)
                }
            }
        );*/
    }

    public setDataValues(data: object) {
        this.office["address"] = data["address"];
        this.office["city"] = data["city"];
        this.office["country"] = data["country"];
        this.office["door"] = data["door"];
        this.office["floor"] = data["floor"];
        this.office["gyh_office"] = parseInt(data["gyh_office"]);
        this.office["notes"] = data["notes"];
        this.office["number"] = data["number"];
        this.office["postal_code"] = data["postal_code"];
        this.office["products"] = parseInt(data["products"]);
    }

    public parseFormData(value:object):void {
        //console.log(value);
        if(value instanceof Object){
            this.contactPersonSelected = value;
            this.contactData.controls["name"].setValue(value["name"]);
            this.contactData.controls["surname"].setValue(value["surname"]);
            this.contactData.controls["phone"].setValue(value["phone"]);
            this.contactData.controls["mail"].setValue(value["email"]);
        }else{
            this.contactPersonSelected = null;
            this.contactData.controls["name"].setValue('');
            this.contactData.controls["surname"].setValue('');
            this.contactData.controls["phone"].setValue('');
            this.contactData.controls["mail"].setValue('');
        }
    }

    private spliceContactPerson(data: object) {

        if(this.office.contactPerson instanceof Array){
            this.office.contactPerson.forEach((element,i) => {
                if(element["id"] == data["id"]){
                    //console.log("entra");
                    this.office.contactPerson.splice(i,1);
                }
            });
        }
    }

    ngOnInit() { 
        //console.log(this.office);
        this.officeData = this._fb.group({
            legalName: [this.office.name, [Validators.required]],
            officeGYH: [this.office.gyh_office, [Validators.required]],
            street: [this.office.address, [Validators.required]],
            number: [this.office.number, [Validators.required]],
            floor: [this.office.floor, []],
            door: [this.office.door, []],
            products: [this.office.products, []],
            postal_code: [this.office.postal_code,[Validators.required,Validators.pattern(PATTERNS["postalCode"])]],
            city: [this.office.city, []],
            country: [this.office.country, []],
            note: [this.office.notes, []],
        });
        this.contactData = this._fb.group({
            name: ['', [Validators.required]],
            surname: ['', [Validators.required]],
            phone: ['', [Validators.required,Validators.pattern(PATTERNS["phone"])]],
            mail: ['', [Validators.required,Validators.pattern(PATTERNS["email"])]]
        });
        this.userService.hideModalObservable().subscribe(data => {
            //console.log(data);
             if(data["type"] == "contact"){
                 this.spliceContactPerson(data["data"]);
             }
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/users/components/dummy/offices.component.ts